import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b6e38dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "form"
}
const _hoisted_2 = { class: "formContent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You password should contain at least:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { id: "password-val-chars" }, "8 characters"),
  /*#__PURE__*/_createElementVNode("li", { id: "password-val-upper" }, "1 uppercase letter"),
  /*#__PURE__*/_createElementVNode("li", { id: "password-val-num" }, "1 number"),
  /*#__PURE__*/_createElementVNode("li", { id: "password-val-special" }, " 1 special character (!, @, #, $, ..) ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "button-submit",
  class: "disabled",
  type: "submit",
  value: "Create account",
  disabled: ""
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "error-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.signupuser && _ctx.signupuser(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              placeholder: "Email",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.passwordValidation && _ctx.passwordValidation(...args))),
              placeholder: "Password",
              required: ""
            }, null, 544), [
              [_vModelText, _ctx.password]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordSecond) = $event)),
              placeholder: "Confirm password",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.passwordSecond]
            ]),
            _hoisted_5
          ])
        ], 32),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]))
}